export default "__VITE_ASSET__DHb7qB4S__"